import { __extends } from "tslib";
import { ASError } from '@awayfl/avm2';
var IOError = /** @class */ (function (_super) {
    __extends(IOError, _super);
    function IOError(message, id) {
        if (message === void 0) { message = ''; }
        if (id === void 0) { id = 0; }
        return _super.call(this, message, id) || this;
    }
    // Called whenever the class is initialized.
    IOError.classInitializer = null;
    // List of static symbols to link.
    IOError.classSymbols = null; // [];
    // List of instance symbols to link.
    IOError.instanceSymbols = null; // [];
    return IOError;
}(ASError));
export { IOError };
